import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import { Code, Gear, PaintBrush, Play } from '@phosphor-icons/react';
import React, { useState } from 'react';

import KitModal from '../../UI/KitModal';
import { CustomizeInterface } from './CustomizeInterface';
import { EmbedOption } from './EmbedOptions';
import { NameAndSetup } from './NameAndSetup';
import { Publish } from './Publish';


type Props = {
  onHide: () => void;
  show: boolean;
  chatData: any;
  setFlow: (arg0: any) => void;
};

const PublishChatModal = ({ onHide, show, chatData, setFlow }: Props) => {
  const [positionTab, setPositionTab] = useState('0');

  const tabItems = [
    { name: 'Name and setup', icon: <Gear size={20} /> },
    { name: 'Customize Interface', icon: <PaintBrush size={20} /> },
    { name: 'Embed Options', icon: <Code size={20} /> },
    { name: 'Publish', icon: <Play size={20} /> },
  ];

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setPositionTab(newValue);
  };
  
  return (
    <KitModal
      sx={{
        '.MuiPaper-root': {
          maxWidth: '1250px',
          width: '100%',
          minHeight: '700px',
          maxHeight: '700px',
        },
        '& .MuiDialogContent-root': {
          padding: '48px 24px',
          textTransform: 'none',
        },
      }}
      show={show}
      onHide={onHide}
    >
      <TabContext value={positionTab}>
        <Box component="main" display="flex">
          <TabList
            onChange={handleChange}
            orientation="vertical"
            variant="scrollable"
            aria-label="Vertical tabs example"
            sx={{
              borderRight: 1,
              borderColor: 'divider',
            }}
          >
            {tabItems.map((item, index) => (
              <Tab
                key={index}
                value={String(index)}
                label={
                  <Box
                    display="flex"
                    gap={2}
                    alignItems="center"
                    width="100%"
                    height="100%"
                  >
                    {item.icon}
                    <span>{item.name}</span>
                  </Box>
                }
              />
            ))}
          </TabList>

          <Box flex={1} height="100%">
            <TabPanel
              value="0"
              sx={{ padding: '0px 16px 0px 24px' }}
            >
              <NameAndSetup chatData={chatData} onSetFlow={setFlow} />
            </TabPanel>
            <TabPanel
              value="1"
              sx={{ padding: '0px 16px 0px 24px' }}
            >
              <CustomizeInterface chatData={chatData} onSetFlow={setFlow} />
            </TabPanel>
            <TabPanel
              value="2"
              sx={{ padding: '0px 16px 0px 24px' }}
            >
              <EmbedOption chatData={chatData} />
            </TabPanel>
            <TabPanel
              value="3"
              sx={{ padding: '0px 16px 0px 24px' }}
            >
              <Publish chatData={chatData} onSetFlow={setFlow} />
            </TabPanel>
          </Box>
        </Box>
      </TabContext>
    </KitModal>
  );
};

export default PublishChatModal;
